import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { z } from 'zod';
import { crewOrderSchema, gspOrderSchema } from '~/utils/schemas';

import {
  completeCrewClaim,
  completeShippingProtectionClaim,
  invalidateLineItem,
  orderEditCommit,
  reset,
  setOrder,
} from './sharedActions';

export const orderStateSchema = z.nullable(
  z.union([crewOrderSchema, gspOrderSchema]),
);

type OrderState = z.infer<typeof orderStateSchema>;

export const orderSlice = createSlice({
  name: 'order',
  initialState: null as OrderState,
  reducers: {
    invalidateOrder: () => null,
  },
  extraReducers: (builder) => {
    builder
      .addCase(
        setOrder,
        (_, action: PayloadAction<OrderState>) => action.payload,
      )

      .addCase(invalidateLineItem, () => null)
      .addCase(completeCrewClaim, () => null)
      .addCase(completeShippingProtectionClaim, () => null)
      .addCase(orderEditCommit, () => null)
      .addCase(reset, (state, { payload }) =>
        payload?.settings && state?.storeSlug === payload.settings.storeSlug
          ? state
          : null,
      );
  },
});
